import { render, staticRenderFns } from "./projectMain.vue?vue&type=template&id=398492a4&scoped=true&"
import script from "./projectMain.vue?vue&type=script&lang=js&"
export * from "./projectMain.vue?vue&type=script&lang=js&"
import style0 from "./projectMain.vue?vue&type=style&index=0&id=398492a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398492a4",
  null
  
)

export default component.exports